
export const theme_ns: ThemeNS = 'kamppiHelsinki2024';
